import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M14 19a6 6 0 0 0-12 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "8", cy: "9", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 19a6 6 0 0 0-6-6 4 4 0 1 0 0-8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Users2";
const Users2 = memo(themed(Icon));
export {
  Users2
};
//# sourceMappingURL=users-2.js.map
